var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_vm._m(0),_c('span',{staticClass:"md:flex hidden items-center"})])
}
var staticRenderFns = [function (_c,_vm){return _c('p',[_c('span',{staticClass:"md:flex hidden items-center"},[_c('span',[_vm._v("Creado por\n        "),_c('a',{attrs:{"href":"https://conexa.ai","target":"_blank","rel":"nofollow"}},[_vm._v("Conexa\n        ")])])])])
}]

export { render, staticRenderFns }